import { useSelector } from "react-redux";
import { selectResourceLinks, selectTitleTexts } from "state/selectors/Selectors";
import { getEnvironment } from "utils/utils";
import TitleComponent from "./TitleComponent";
import { TooltipComponent } from "./toolTipComponent/TooltipComponent";
import { STARTPAGETITLES } from "InterfacesTypes/enums";

const FrequentlyVisitedLinks = () => {
  const env = getEnvironment();
  const resourceLinksItems = useSelector(selectResourceLinks);
  const titleTexts = useSelector(selectTitleTexts);
  const iconLinks = resourceLinksItems.filter(
    (link) => link.FrequentlyVisited == true
  );

  const mostlyVisitedTitle = titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.MOSTLY_VISITED_TITLE);

  return (
    <div>
      {mostlyVisitedTitle?.Description ?
        <TooltipComponent
          className="w-full"
          placement="top"
          content={mostlyVisitedTitle?.Description}
        >

          <TitleComponent
            title={mostlyVisitedTitle?.Title ?? "Titel saknas"}
            className="pt-1"
          />
        </TooltipComponent>
        :
        <TitleComponent
          title={mostlyVisitedTitle?.Title ?? "Titel saknas"}
          className="pt-1"
        />
      }
      {iconLinks.map((link, index) => (
        <a
          href={link.Link}
          key={index}
          className="flex flex-col !my-2
            !bg-[rgba(255,255,255,0.21)] 
            shadow-[0_4px_30px_rgba(0,0,0,0.1)] 
            backdrop-blur-[20px]
             border border-white/53
              hover:-translate-y-[2px] 
              !rounded-lg p-2 
              !text-[rgb(44,43,43)] 
              ml-1
              items-center 
              justify-center 
              hover:scale-105 
              transition-transform duration-600 
              !no-underline 
              hover:!no-underline"
        >
          <div
            className="!flex  !w-full !rounded-lg  !p-2
            relative isolate rounded-[16px]
            grid !place-items-center
            !bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
            border border-[rgba(255,255,255,0.18)]
            backdrop-blur-[8px] backdrop-saturate-[120%]
            !shadow-[0_10px_20px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.12)]
            transition-[transform,box-shadow,border-color] duration-[220ms] ease
            hover:-translate-y-[3px] hover:!shadow-[0_14px_28px_rgba(0,0,0,0.35)] hover:border-white
            focus-within:-translate-y-[3px] focus-within:!shadow-[0_14px_28px_rgba(0,0,0,0.35)] focus-within:!border-white
            hover:bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
            focus-within:!bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
          "
          >
            <img
              className="!border-none !h-[30px] !w-[30px] leading-none align-middle !pl-1"
              src={`${env.imageUrl}${link.Image}`}
            />
            <div className="text-base !px-2">{link.Title}</div>
          </div>
        </a>
      ))}
    </div>
  );
};
export default FrequentlyVisitedLinks;
